// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__3NYe4","checkbox__element":"checkbox_checkbox__element__PacN7","checkbox__bg":"checkbox_checkbox__bg__1zVf_"};